import { Form, Input } from 'antd-v5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SettingsContent } from '../../../components/SettingsContent';
import DescriptionBox from '../../../../../../components/Layout/DescriptionBox';

export const AppAccountSettings = ({ licenseKey, merchantPassword }) => {
  return (
    <SettingsContent title="APP ACCOUNT INFO" icon={<FontAwesomeIcon icon={['fas', 'key']} />} className="w-100-P">
      <DescriptionBox
        className="w-100-P"
        title="Account ID"
        description="This is the Account ID you'll use when logging in to the mobile app"
        input={
          <Input
            id="AccountIdInput"
            value={licenseKey}
            readOnly
            disabled
            style={{ minWidth: '200px', backgroundColor: '#f3f3f3', color: 'black' }}
          />
        }
      />
      <DescriptionBox
        className="w-100-P"
        title="Password"
        input={
          <Input
            id="PasswordIdInput"
            value={merchantPassword}
            readOnly
            disabled
            style={{ minWidth: '200px', backgroundColor: '#f3f3f3', color: 'black' }}
          />
        }
      />
    </SettingsContent>
  );
};
